import React, { useEffect, useState } from 'react';

const Gallery = props => {
  const [selectedImage, setSelectedImage] = useState(null)

  useEffect(() => {
    const handleScroll = () => {
      console.log('scroll')
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [])

  const handleSelectedImage = index => setSelectedImage(selectedImage === index ? null : index)

  return (
    <div className='gallery' onScroll={console.log('scroll gal')}>
      <div id='gallery-row' onScroll={console.log('scroll row')}>
        {
          (props.images || [])
            .filter(item => item.image && item.image.childImageSharp)
            .map((item, index) =>
            <div key={item.name || index} style={{ position: 'relative' }} onScroll={console.log('scroll unit')}>
              <img 
                className={`full-image ${index === selectedImage ? 'blur' : '' }`}
                src={item.image.childImageSharp.fluid.originalImg}
                onClick={() => handleSelectedImage(index)}
              />
              {
                index === selectedImage &&
                  <div className='overlay'>
                    <p> {item.name}</p>
                  </div>
              }
            </div>
          )
        }
      </div>
      
    </div>
  )
}

export default Gallery;
